import { Div, CollectionView, TableBuilder, Line } from "@tblabs/truffle";
import { Order } from "../../../Models/Order";
import { TimeUtils } from "../../../Utils/TimeUtils";


export class OriginsView extends Div
{
    constructor(private orders: CollectionView<Order>)
    {
        super();

        const originsCount: Record<string, number> = {};
        this.orders.Items.forEach(order =>
        {
            const origin = order.People.First()?.Origin?.value || "(brak źródła)";
            if (origin && origin.trim())
            {
                originsCount[origin] = (originsCount[origin] || 0) + 1;
            }
        });

        const origins = Object.entries(originsCount).map(([origin, count]) => ({ origin, count }));

        this.Append(
            new TableBuilder(origins)
                .AddColumn("Źródło", x => x.origin)
                .AddColumn("Ilość", x => x.count)
                .Build()
                .Class("uk-table uk-table-small uk-table-divider").MarginAuto().WidthAuto(),

            new Line(),

            new TableBuilder(this.orders)
                .AddColumn("Zamówienie", x => "#" + x.ShortId)
                .AddColumn("Utworzone", x => TimeUtils.FormattedDate(x.Meta.CreatedAt))
                .AddColumn("Status", x => x.Status)
                .AddColumn("Źródło", x => x.People.First()?.Origin?.value || "")
                .AddColumn("Profit", x => x.Profit + " zł")
                .Build()
                .WidthAuto().MarginAuto()
        );
    }
}
